import React from "react";
import { RecommendationMap, CiidMapProps } from "./RecommendationMap";

export const GoogleMapRecommendation = (props: CiidMapProps) => {
  return <RecommendationMap {...props} />;
};
